// src/pages/We/We.js
import { useRefs } from '../../context/RefContext'
import './We.scss'
import Aos from 'aos';
import 'aos/dist/aos.css'; // Corrected AOS CSS import
import { useEffect } from 'react';
import { useLingui } from "@lingui/react"; // <--- Import useLingui


// Import FontAwesome icons (only those used)
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons' // Fixed regular-svg-icons import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";

// Import a single placeholder image, which will be used for all 5 people for now
import allCards from '../../data/peopleCards.js'; // Our simulated data


import founderPlaceholder from '../../images/founder_pholder.png';
import whiteLogo from '../../images/logo_white.png'; // Your white inverted logo
// Import the new specific logos
import sogiLogo from '../../images/logo_sogi.png'; 
import witmoLogo from '../../images/logo_witmo_horiz.png'; 
import vengLogo from '../../images/logo_veng.png'; 
import halLogo from '../../images/hal_tr.png'
import gvvLogo from '../../images/gvv_tr.png'


const We = () => {
    const { i18n } = useLingui();
//    const { weRef } = useRefs();
    
    useEffect(() => {
        Aos.init({ duration: 1000, once: true, easing: 'ease-in-out' });
    }, []);

    const peopleData = allCards[i18n.locale] || allCards['es'] || [];
    const visiblePeople = peopleData.filter(person => person.show).sort((a,b)=> a.id - b.id);

    return (
        <div className='people-section'> 
            <div className="unified-team-container">
                
                {/* This div is purely for the visual "White Strip" background on desktop */}
                <div className="desktop-strip-bg"></div>

                <div className="team-grid">
                    {visiblePeople.map((member, index) => (
                        <div className="team-card" key={member.id} data-aos="fade-in" data-aos-delay={100 * index}>
                            
                            {/* PART 1: IMAGE */}
                            <div className="card-image-wrapper">
                                <img 
                                    src={`${process.env.PUBLIC_URL}/images/profiles/${member.image}`} 
                                    alt={`${member.name}`} 
                                />
                            </div>

                            {/* PART 2: INFO */}
                            <div className="card-info-wrapper">
                                <div className="info-main-content">
                                    <h4>{member.name}</h4>
                                    <h3>{member.position}</h3>
                                    <div dangerouslySetInnerHTML={{__html: member.bodyCard}}></div>
                                </div>
                                <div className="info-footer"> 
                                    <hr className="info-separator" />
                                    <div className="social-icons">
                                        {member.lkd && (
                                            <a href={member.lkd} target="_blank" rel="noopener noreferrer" className="icon">
                                                <FontAwesomeIcon icon={faLinkedinIn} />
                                            </a>
                                        )} 
                                        {member.email && (
                                            <a href={`mailto:${member.email}`} className="icon">
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

              <div className="founding-companies-section">
                <div className="company-column">
                   <div className="column-title"> {/* Esta manera maás un @extend (block y block outline a strong y em), para que el lingui parser funcione.*/}
                        <Trans>
                            <strong>SOCIOS</strong> <em>CORPORATIVOS</em>
                        </Trans>
                   </div>
                  <div className="logos-container">
                     <a href="https://sogi.com.ar" target="_blank" rel="noopener noreferrer"><img className="dark-original" src={sogiLogo} alt="SOGi - Switch on Global Intelligence Logo" /></a>
                     <a href="https://witmo.com.ar" target="_blank" rel="noopener noreferrer"><img src={witmoLogo} alt="Witmo Technologies Logo" /></a>
                  </div>
                </div>          
              {/* Right Column */}
                 <div className="company-column">
                  <div className="column-title">
                    <Trans>
                    <strong>ALIANZAS</strong> <em>ESTRATÉGICAS</em>
                    </Trans>
                  </div>
                  <div className="logos-container">
                     <a href="https://veng.com.ar" target="_blank" rel="noopener noreferrer"><img  className="dark-original"  src={vengLogo} alt="VENG Logo" /></a>
                     <a href="https://www.linkedin.com/in/arqhugolarotondaestudiohal/" target="_blank" rel="noopener noreferrer"><img  className="dark-original"  src={halLogo} alt="HAL Logo" /></a>
                     <a href="https://estudioggvv.blogspot.com/" target="_blank" rel="noopener noreferrer"><img   className="dark-original"  src={gvvLogo} alt="GVV Logo"/></a>
                  </div>
                </div>     
            </div>


        </div>
    );
}

export default We;